import React from 'react'
import { ClickAwayListener, Popper } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'

import DownArrowSmallIcon from '../../icons/DownArrowSmallIcon'

import { loadBaseInboxes, selectBaseInbox } from '../../../slices/baseInbox'

import useStyles from './styles'

interface FolderSelectMenuProps {
  onSelect: (inbox: APIBaseInbox) => void
}

const FolderSelectMenu: React.FC<FolderSelectMenuProps> = ({ onSelect }) => {
  const dispatch = useAppDispatch()
  const { loaded, inboxes } = useAppSelector(selectBaseInbox)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [selectedInbox, setSelectedInbox] = React.useState(null)
  const open = React.useMemo(() => Boolean(anchorEl), [anchorEl])
  const mainRef = React.useRef<HTMLDivElement | null>(null)

  const classes = useStyles({
    parentWidth: mainRef?.current?.getBoundingClientRect().width || 480
  })

  React.useEffect(() => {
    if (!loaded) {
      dispatch(loadBaseInboxes())
    }
  }, [loaded, dispatch])
  // Opens menu
  const handleClick = React.useCallback(e => {
    const target = e.currentTarget
    setAnchorEl(old => (old ? null : target))
  }, [])

  // Closes menu and resets state
  const handleClose = React.useCallback(() => {
    setAnchorEl(null)
  }, [])

  // Callback for when something is clicked
  const handleSelect = React.useCallback(
    inbox => {
      onSelect(inbox)
      setSelectedInbox(inbox)
      handleClose()
    },
    [onSelect, handleClose]
  )

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <div ref={mainRef} onClick={handleClick} className={classes.root}>
          <div className={classes.selectedInbox}>
            {selectedInbox?.name ?? (
              <label className={classes.noSelected}>No Inbox Selected</label>
            )}
          </div>

          <DownArrowSmallIcon className={classes.arrow} />
        </div>

        {open && (
          <Popper
            open={open}
            anchorEl={anchorEl}
            style={{ zIndex: '1500' }}
            placement='bottom-start'
          >
            <div className={classes.menu}>
              <div className={classes.items}>
                {inboxes.map(inbox => (
                  <div
                    key={inbox.id}
                    onClick={() => handleSelect(inbox)}
                    className={classes.item}
                  >
                    {inbox.name}
                  </div>
                ))}
              </div>
            </div>
          </Popper>
        )}
      </div>
    </ClickAwayListener>
  )
}

export default FolderSelectMenu
